<template>
  <v-btn
    v-if="currentSection"
    dark
    fixed
    :color="showPulse ? '#1e88e5' : '#607d8b'"
    :class="{ 'help-btn-pulse': showPulse }"
    style="z-index: 200; top: 50%; right: 0; transform: translateY(-50%); border-radius: 6px 0 0 6px !important; min-width: 28px !important; width: 28px !important; height: 56px !important; padding: 0 !important;"
    @click="onHelpClick"
  >
    <v-icon size="18">mdi-help-circle-outline</v-icon>
  </v-btn>
</template>

<script>
import TutorialService from "../../services/TutorialService";

export default {
  name: "BaseHelpButton",

  data: function () {
    return {
      currentSection: null,
      showPulse: false,
      autoTriggerTimer: null
    };
  },

  watch: {
    "$route.path": {
      handler: function (newPath) {
        this.onRouteChange(newPath);
      },
      immediate: true
    }
  },

  methods: {
    onRouteChange: function (path) {
      TutorialService.stopTour();
      if (this.autoTriggerTimer) {
        clearTimeout(this.autoTriggerTimer);
        this.autoTriggerTimer = null;
      }

      var section = TutorialService.getSectionForRoute(path);
      this.currentSection = section;

      if (section) {
        var completed = TutorialService.isTutorialCompleted(section);
        this.showPulse = !completed;

        if (!completed) {
          this.scheduleAutoTour(section);
        }
      } else {
        this.showPulse = false;
      }
    },

    scheduleAutoTour: function (section) {
      var self = this;
      self.autoTriggerTimer = setTimeout(function () {
        var currentSection = TutorialService.getSectionForRoute(self.$route.path);
        if (currentSection === section && !TutorialService.isRunning()) {
          if (!TutorialService.isTutorialCompleted(section)) {
            self.startTourForSection(section);
          }
        }
      }, 1500);
    },

    onHelpClick: function () {
      if (!this.currentSection) return;

      if (TutorialService.isRunning()) {
        TutorialService.stopTour();
        return;
      }

      this.startTourForSection(this.currentSection);
    },

    startTourForSection: function (section) {
      var self = this;
      TutorialService.startTour(section, function () {
        self.showPulse = false;
      });
    }
  },

  beforeDestroy: function () {
    TutorialService.stopTour();
    if (this.autoTriggerTimer) {
      clearTimeout(this.autoTriggerTimer);
    }
  }
};
</script>

<style>
/* Pulse animation for the FAB */
@keyframes helpBtnPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(30, 136, 229, 0.6);
  }
  70% {
    box-shadow: 0 0 0 16px rgba(30, 136, 229, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(30, 136, 229, 0);
  }
}

.help-btn-pulse {
  animation: helpBtnPulse 2s infinite;
}

/* Driver.js popover customization */
.tutorial-popover {
  font-family: "Roboto", sans-serif !important;
}

.tutorial-popover .driver-popover-title {
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  color: #1e88e5 !important;
}

.tutorial-popover .driver-popover-description {
  font-size: 0.9rem !important;
  color: #455a64 !important;
  line-height: 1.5 !important;
}

.tutorial-popover .driver-popover-progress-text {
  font-size: 0.75rem !important;
  color: #90a4ae !important;
}

.tutorial-popover .driver-popover-next-btn {
  background-color: #1e88e5 !important;
  color: #fff !important;
  border: none !important;
  text-shadow: none !important;
}

.tutorial-popover .driver-popover-prev-btn {
  color: #455a64 !important;
  border-color: #cfd8dc !important;
  text-shadow: none !important;
}

.tutorial-popover .driver-popover-close-btn {
  color: #90a4ae !important;
}
</style>
